import { createTheme } from "@mui/material/styles";

// example theme
export const Theme = createTheme({
  palette: {
    default: {
      main: "#FFA750",
    },
    bg: "#0a0a0a",
    surface: "#111111",
    card: "#161616",
    gold: "#facc15",
    silver: "#94a3b8",
    bronze: "#cd7c3e",
    blue: "#60a5fa",
    border: "#1e1e1e",
    borderLight: "#252525",
    orange: "#f97316",
    orangeDark: "#ea580c",
    text: "#f5f5f5",
    textSub: "#b0b0b0",
    muted: "#555",
    dim: "#333",
    down: "#ff3b5c",
    up: "#22d47b",
    purple: "#c084fc",
  },
});
